<template>
  <ContentWithImage class="unsubscribe" src="unsubscribe" image-order="1" image-order-sm="1" margin="50px 0">
    <text-container>
      <h2 class="h1" v-html="$t(`unsubscribe.title`)"/>
      <p v-html="$t(`unsubscribe.text`)"/>
      <template v-if="thankYou">
        <h3>Thank you for your submission!</h3>
      </template>
      <template v-else>
        <input v-model="unsubscribeEmail" type="email" name="email" value="" class="form-control" aria-describedby="emailHelp" placeholder="E-mail address">
        <div v-if="invalidEmail" class="error">Email is invalid</div>
        <b-btn class="mt-2" variant="primary" @click="sendEmail">
          {{$t(`unsubscribe.btn`)}}
        </b-btn>
      </template>
    </text-container>
  </ContentWithImage>
</template>

<script>
import { ContentWithImage } from '@/components/ui'
import axios from 'axios'

export default {
  name: 'Unsubscribe',
  components: { ContentWithImage },
  data () {
    return {
      unsubscribeEmail: '',
      invalidEmail: false,
      thankYou: false
    }
  },
  methods: {
    validEmail (email) {
      const re = /(.+)@(.+){2,}\.(.+){2,}/
      return re.test(email.toLowerCase())
    },
    showThankYou () {
      this.thankYou = true
    },
    sendEmail () {
      if (this.validEmail(this.unsubscribeEmail)) {
        let data = new FormData()
        data.append('from', process.env['EMAIL_FROM'])
        data.append('to', process.env['MARKETING_ADDRESS'])
        data.append('subject', 'HRDownloads.com Unsubscribe Request')
        data.append('body', 'Email to unsubscribe - ' + this.unsubscribeEmail)

        axios.post(`${process.env['CMS_DOMAIN']}/api/contact`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(() => {
            this.invalidEmail = false
            this.showThankYou()
          })
          .catch(err => console.log(err))
      } else {
        this.invalidEmail = true
      }
    }
  }
}
</script>

<style lang="sass">
.unsubscribe
  img
    max-width: 400px!important
    +media-breakpoint-down(xs)
      max-width: 350px!important

.error
  color: red
</style>

<style lang="sass" scoped>
.center
  text-align: center
.form-control::placeholder
  color: #6c757d
  opacity: 1

.text-container
  text-align: left!important
  justify-content: start!important
  justify-items: start!important
</style>



// WEBPACK FOOTER //
// src/components/errors/Unsubscribe.vue